import index from "./tads.vue";
export default index;
